export class UniqueId {
  private static maxId = 1;
  private static queue: number[] = [];

  static generateUniqueId() {
    let newId = this.queue.pop();
    if (newId) {
      return newId;
    }

    newId = this.maxId;
    this.maxId++;

    return newId;
  }

  static deleteUniqueId(id: number) {
    this.queue = [id, ...this.queue];
  }

  static clear() {
    this.maxId = 1;
    this.queue = [];
  }
}
